import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
// --- ADD THIS IMPORT ---
import { HashRouter } from 'react-router-dom';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        {/* --- WRAP APP IN HASHROUTER --- */}
        <HashRouter>
            <App />
        </HashRouter>
    </React.StrictMode>
);